module.exports = __webpack_public_path__ + "img/baby_man.ee5d4b57.png";